type IdealDueDates = {
  [day: number]: number;
};

export const calculateIdealDueDate = (dayActivated: number): number => {
  const idealDueDates: IdealDueDates = {
    1: 7,
    2: 7,
    3: 7,
    4: 7,
    5: 7,
    6: 7,
    7: 10,
    8: 10,
    9: 10,
    10: 10,
    11: 10,
    12: 12,
    13: 12,
    14: 12,
    15: 12,
    16: 15,
    17: 15,
    18: 15,
    19: 20,
    20: 20,
    21: 20,
    22: 20,
    23: 20,
    24: 1,
    25: 1,
    26: 1,
    27: 1,
    28: 1,
    29: 7,
    30: 7,
    31: 7,
  };

  return idealDueDates[dayActivated] || 1;
};
